
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/riboflam",
      function () {
        return require("private-next-pages/riboflam.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/riboflam"])
      });
    }
  